import script from "./MainSubHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainSubHeader.vue?vue&type=script&lang=ts&setup=true"

import "./MainSubHeader.vue?vue&type=style&index=0&id=d3f87c6c&lang=scss"
import "./MainSubHeader.vue?vue&type=style&index=1&id=d3f87c6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3f87c6c"]])

export default __exports__